// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _FieldStringOutlined = /*#__PURE__*/ _interop_require_default(require("@ant-design/icons-svg/lib/asn/FieldStringOutlined"));
var _AntdIcon = /*#__PURE__*/ _interop_require_default(require("../components/AntdIcon"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var FieldStringOutlined = function(props, ref) {
    return /*#__PURE__*/ _react.createElement(_AntdIcon.default, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        icon: _FieldStringOutlined.default
    }));
};
/**![field-string](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik04NzUuNiA1MTUuOWMyLjEuOCA0LjQtLjMgNS4yLTIuNC4yLS40LjItLjkuMi0xLjR2LTU4LjNjMC0xLjgtMS4xLTMuMy0yLjgtMy44LTYtMS44LTE3LjItMy0yNy4yLTMtMzIuOSAwLTYxLjcgMTYuNy03My41IDQxLjJ2LTI4LjZjMC00LjQtMy42LTgtOC04SDcxN2MtNC40IDAtOCAzLjYtOCA4VjcyOWMwIDQuNCAzLjYgOCA4IDhoNTQuOGM0LjQgMCA4LTMuNiA4LThWNTcyLjdjMC0zNi4yIDI2LjEtNjAuMiA2NS4xLTYwLjIgMTAuNC4xIDI2LjYgMS44IDMwLjcgMy40em0tNTM3LTQwLjVsLTU0LjctMTIuNmMtNjEuMi0xNC4yLTg3LjctMzQuOC04Ny43LTcwLjcgMC00NC42IDM5LjEtNzMuNSA5Ni45LTczLjUgNTIuOCAwIDkxLjQgMjYuNSA5OS45IDY4LjloNzBDNDU1LjkgMzExLjYgMzg3LjYgMjU5IDI5My40IDI1OWMtMTAzLjMgMC0xNzEgNTUuNS0xNzEgMTM5IDAgNjguNiAzOC42IDEwOS41IDEyMi4yIDEyOC41bDYxLjYgMTQuM2M2My42IDE0LjkgOTEuNiAzNy4xIDkxLjYgNzUuMSAwIDQ0LjEtNDMuNSA3NS4yLTEwMi41IDc1LjItNjAuNiAwLTEwNC41LTI3LjItMTEyLjgtNzAuNUgxMTFjNy4yIDc5LjkgNzUuNiAxMzAuNCAxNzkuMSAxMzAuNEM0MDIuMyA3NTEgNDcxIDY5NS4yIDQ3MSA2MDUuM2MwLTcwLjItMzguNi0xMDguNS0xMzIuNC0xMjkuOXpNODQxIDcyOWEzNiAzNiAwIDEwNzIgMCAzNiAzNiAwIDEwLTcyIDB6TTY1MyA0NTcuOGgtNTEuNFYzOTZjMC00LjQtMy42LTgtOC04aC01NC43Yy00LjQgMC04IDMuNi04IDh2NjEuOEg0OTVjLTQuNCAwLTggMy42LTggOHY0Mi4zYzAgNC40IDMuNiA4IDggOGgzNS45djE0Ny41YzAgNTYuMiAyNy40IDc5LjQgOTMuMSA3OS40IDExLjcgMCAyMy42LTEuMiAzMy44LTMuMSAxLjktLjMgMy4yLTIgMy4yLTMuOXYtNDkuM2MwLTIuMi0xLjgtNC00LTRoLS40Yy00LjkuNS02LjIuNi04LjMuOC00LjEuMy03LjguNS0xMi42LjUtMjQuMSAwLTM0LjEtMTAuMy0zNC4xLTM1LjZWNTE2LjFINjUzYzQuNCAwIDgtMy42IDgtOHYtNDIuM2MwLTQuNC0zLjYtOC04LTh6IiAvPjwvc3ZnPg==) */ var RefIcon = /*#__PURE__*/ _react.forwardRef(FieldStringOutlined);
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'FieldStringOutlined';
}
var _default = RefIcon;
